import React, { ReactElement } from 'react'
import { NavLink } from '@mindfulchefuk/features/Navigation/components/Header/shared'
import { NavLinkData } from '@mindfulchefuk/features/Navigation/interfaces'
import { useSignedOutNavMobileContext } from '@mindfulchefuk/features/Navigation/components/Header/SignedOutNav/context/SignedOutNavMobileContext'
import { trackAnalyticsEvent } from '@mindfulchefuk/utils/analytics/amplitude/amplitudeAdapter'

type TSignedOutNavMobileSubItems = {
  sublink: NavLinkData
}

export const SignedOutNavMobileSubItems = ({
  sublink,
}: TSignedOutNavMobileSubItems): ReactElement => {
  const { handleCloseMobileNav } = useSignedOutNavMobileContext()

  const onLinkClick = (label: string) => {
    trackAnalyticsEvent({
      name: 'nav link clicked',
      data: {
        'link name': label,
        section: 'top nav',
        'page source': 'homepage',
      },
    })
    handleCloseMobileNav()
  }
  return (
    <li key={sublink.id} style={{ paddingLeft: '30px' }}>
      <NavLink
        {...sublink}
        onClick={() => onLinkClick(sublink.label)}
        external={sublink.route === 'external'}
      />
    </li>
  )
}
